import React from 'react';

interface ContextValue
  extends Readonly<{
    params?: object;
  }> {}

const Context = React.createContext<ContextValue>({});

export interface NavigationParamsContextProviderProps
  extends Readonly<{
    params?: object;
    children?: React.ReactNode;
  }> {}

export const NavigationParamsContextProvider = React.memo<NavigationParamsContextProviderProps>((props) => {
  const { params, children } = props;

  const ContextValue = React.useMemo(() => {
    const contextValue: ContextValue = {
      params,
    };

    return contextValue;
  }, [params]);

  return <Context.Provider value={ContextValue}>{children}</Context.Provider>;
});

export const useNavigationParamsContext = () => React.useContext<ContextValue>(Context);
